import styles from "./DefaultLoader.module.css";

export const DefaultLoader = ({width, height}) => {
    return (
        <span style={{width, height}} className={styles.loader}></span>

    )
}
